import * as React from 'react';

const LaughingFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 24.004c0-11.05 8.95-20 20-20s20 8.95 20 20-8.95 20-20 20-20-8.95-20-20Zm1.5 0c0 10.2 8.3 18.5 18.5 18.5s18.5-8.3 18.5-18.5-8.3-18.5-18.5-18.5-18.5 8.3-18.5 18.5Zm12.75-4.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM31 20.754a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-16.568 6.22h19.14c.99 0 1.73.91 1.45 1.81-1.52 4.8-6.34 7.23-11.07 7.23s-9.45-2.39-10.97-7.23c-.29-.9.46-1.81 1.45-1.81Zm9.506 7.53c-3.461-.023-8.017-1.621-9.486-6.04l19.08.02c-1.49 4.408-6.093 5.997-9.594 6.02Z",
    clipRule: "evenodd"
  }
));
LaughingFace48.Size = 48;
LaughingFace48.Title = "LaughingFace";

export { LaughingFace48 as default };
